// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__fmGsW","selected":"Chip_selected__1OLOg"};